import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=2208cb67&"
import script from "./ArticleListItem.vue?vue&type=script&lang=js&"
export * from "./ArticleListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports